import type {CatalogueCoursesModel, CatalogueFilterModel, AntiForgery} from './api.ts';

export const searchCourses = async (
    data: CatalogueFilterModel,
    antiForgery: AntiForgery,
    signal:AbortSignal): Promise<CatalogueCoursesModel>  => {
    const response = await fetch('/restapi/course/catalogue/external/v1', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            [antiForgery.antiForgeryHeaderName]: antiForgery.antiForgeryHeaderValue
        },
        body: JSON.stringify(data),
        signal
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json() as CatalogueCoursesModel;
};
